import React, { useState } from "react";
import {
    Col,
    Row,
    Card,
    CardBody,
    Modal,
    ModalBody,
} from "reactstrap";
import { AvField, AvForm } from "availity-reactstrap-validation";
import { SuccessOk } from "configs/statusCode";
import { toast } from "react-toastify";

const MessageModal = ({ modal, id, Service, setModal}) => {
    const [loading, setLoading] = useState(false)
    const [message, setMessage] = useState('')

    const handleValidSubmit = (e, v) => {
        setLoading(true)
        let data = {
            lead_id: id,
            message: message
        }
        Service.sendCil(data).then(res => {
            if (res && res.status === SuccessOk) {
                toast.success("Message Sent Successfully")
                setModal(false)
            }
            setLoading(false)
        })
    }

    return (
        <Modal
            isOpen={modal}
            toggle={() => setModal(false)}
            style={{ maxWidth: '600px', marginTop: "10%", width: '100%' }}
        >
            <ModalBody className="m-0 p-0 fw-bold">
                <Card className='overflow-hidden m-0 p-0' style={{ direction: "inherit" }}>
                    <CardBody className=' p-0 m-0'>
                        <Row className="m-4 fw-bold font-size-16" >
                            Send Message
                        </Row>
                        
                        <Row className="my-4 mx-2 fw-bold font-size-16">
                            <AvForm
                                className='form-horizontal'
                                onValidSubmit={(e, v) => {
                                    handleValidSubmit(e, v)
                                }}>
                                <AvField
                                    name='message'
                                    placeholder='Type Message'
                                    className='form-control'
                                    style={{height: '150px'}}
                                    type="textarea"
                                    bsSize="lg"
                                    onChange={(e)=> setMessage(e.target.value)}
                                />
                                <Row className="mt-4">
                                    <Col md={9}></Col>
                                    <Col md={3}>
                                        <button
                                            className="btn btn-success btnHeight px-4 float-end"
                                            disabled={loading}
                                        >Submit</button>
                                    </Col>
                                </Row>
                            </AvForm>
                        </Row>
                    </CardBody>
                </Card>
            </ModalBody>
        </Modal>
    )
}

export default MessageModal